module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1"
  }, [_c('p', {
    staticClass: "CN"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page7",
      "title": "7"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor006"
    }
  }), _vm._v(" Chapter 1")])]), _vm._v(" "), _c('p', {
    staticClass: "_CT",
    attrs: {
      "id": "_idParaDest-7"
    }
  }, [_vm._v("The Morrigan: Who She Is "), _c('br'), _vm._v("and Who She Isn’t")]), _vm._v(" "), _c('p', {
    staticClass: "txnoidc"
  }, [_c('span', {
    staticClass: "_idGenDropcap-1"
  }, [_vm._v("T")]), _vm._v(" he Morrigan is complex; she has filled many roles for both those who worshipped her in the past and those who hear her call today. She is an Irish goddess connected to war, sovereignty, shape-shifting, magic, and much more. I remember a time not so long ago when the Morrigan was deemed too dangerous to work with by modern practitioners. Yet now she is everywhere, regaining followers and appearing frequently in modern literature, comic books, and even in TV series. The Morrigan is popular now in modern Paganism too, something I never imagined would happen. But still I fear the Morrigan is misunderstood. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Who is she really? I hope you will find the answer to that question in these pages. My own understanding of the Morrigan and her nature has evolved over time. It has come from multiple sources: first in encountering her in a dream, then through many years of reading her mythology and learning about the culture she came from in order to understand whom I had met in that dream. The lore and mythology remain my anchor in my understanding of her, but my understanding is also tempered with my own personal experiences with her over the last twenty years. For a being so vast, with so many aspects and so many competing notions of who exactly makes up this multifaced goddess, it is often difficult to sort out who or what she actually is. I’ve often run in philosophical and historical circles in my head trying to understand the being, the power, I am devoted to. Trying to understand the nature of a god is like trying to envision the depth and breadth of the universe, the sheer vastness of it. It is contemplating dark matter and what the life of atoms might be like. My understanding of her has certainly evolved since our first encounter, and I’m "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page8",
      "title": "8"
    }
  }, [_vm._v("sure it will continue to evolve. Sometimes that is the point of a mystery, that it unfolds slowly and only has meaning in the context of the journey itself. ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Before we take a closer look at some of the more complicated aspects of the Morrigan’s nature, let us look at some of the basics about her personality as well as address some of the most common questions I encounter about her. ")]), _vm._v(" "), _c('p', {
    staticClass: "Ahead"
  }, [_vm._v("The Morrigan Q and A")]), _vm._v(" "), _c('p', {
    staticClass: "Bhead-nsa"
  }, [_vm._v("Does the "), _c('span', {
    staticClass: "dante-med"
  }, [_vm._v("the")]), _vm._v(" matter? Is it the Morrigan or just Morrigan?")]), _vm._v(" "), _c('p', {
    staticClass: "tx-ni"
  }, [_vm._v("As you may have noticed, the Morrigan’s ("), _c('span', {
    staticClass: "ital"
  }, [_vm._v("MOR-ree-guhn")]), _vm._v(") name appears with a definite article. The "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("the")]), _vm._v(" really does matter. It’s how her name appears in Irish mythology, and we find that many Irish gods have definite articles as part of their names, the Dagda being an example. "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("The Morrigan")]), _vm._v(" does not necessarily indicate a plural, so it is used to indicate a singular character as well as the plural grouping of the three sisters born to Ernmas. The plural of "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("Morrigan")]), _vm._v(" would be "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("Morrignae")]), _vm._v(" or "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("Morrigna")]), _vm._v(". I have seen people refer to her as Goddess Morrigan or just Morrigan, but it’s just not how she was referred to in the culture she originates from. The "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("the")]), _vm._v(" matters because it’s still part of her name and how she has been referenced historically. It should also remind us that most of the time we aren’t dealing with a single being but a grouping of goddesses. ")]), _vm._v(" "), _c('p', {
    staticClass: "Bhead"
  }, [_vm._v("Is the Morrigan one goddess, three goddesses, or a multitude?")]), _vm._v(" "), _c('p', {
    staticClass: "tx-ni"
  }, [_vm._v("Like many Irish deity names, "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("the Morrigan")]), _vm._v(" can also indicate a title of a grouping of goddesses. Let’s go back to the source material to see who is part of that grouping. The"), _c('span', {
    staticClass: "ital"
  }, [_vm._v(" Lebor Gab")]), _c('span', {
    staticClass: "ital",
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }, [_vm._v("á")]), _c('span', {
    staticClass: "ital"
  }, [_vm._v("la ")]), _c('span', {
    staticClass: "ital",
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }, [_vm._v("Érenn")]), _c('span', {
    staticClass: "ital"
  }, [_vm._v(", ")]), _vm._v("also known as "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("The Book of Invasions")]), _vm._v(", contains several genealogies of the Irish gods as well at detailed migrations or “invasions” of several divine races to the island. Most modern readers would think that this work is a single book, but there are actually several versions, or what are called recensions. In it we find a very specific trio named in multiple parts of the text as the sisters who form the Morrigan. Also we find her mother consistently named as the goddess Ernmas: “Ernmas had other three daughters, Badb and Macha and Morrigu, whose name was Anand.” "), _c('span', {
    staticClass: "fnref _idGenCharOverride-2"
  }, [_c('span', {
    attrs: {
      "id": "footnote-010-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/PM2#footnote-010"
    }
  }, [_vm._v("1")])])]), _vm._v(" That makes Macha, Badb, and Anu the definitive trio that forms the Morrigan. Next to nothing is left to us about their mother other than her name, but the consistency in "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page9",
      "title": "9"
    }
  }, [_vm._v("which she is named with them would suggest that it was understood that this lineage and grouping of sisters was the widely accepted one. ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("But as most devotees of the Morrigan are aware, there is a whole host of other goddesses who are connected to or are lumped into this collective that forms the Great Queen. Because nothing can be simple with the Morrigan, this can make it rather difficult to figure out what deities are considered part of this collective. Who is the Morrigan? Is she a single being? Or many? And who fits into this collective of war goddesses?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("We can say with certainty that she appears as both one and many. For example, in the "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("Táin Bó Regamna ")]), _vm._v("she is a red-haired woman whom Cuchulain challenges."), _c('span', {
    staticClass: "fnref _idGenCharOverride-2"
  }, [_c('span', {
    attrs: {
      "id": "footnote-009-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/PM2#footnote-009"
    }
  }, [_vm._v("2")])])]), _vm._v(" Here she is identified as "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("the Morrigan")]), _vm._v(", even though she is a singular character. In the story of Odras and in at least one version of her yearly meeting with the Dagda at a river ford, she is an individual being identified as "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("the Morrigan")]), _vm._v(". In other cases, such as in "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("The First Battle of Moytura,")]), _vm._v(" we are told the three Morrigans—Anu, Macha, and Badb—attack the Fir Bolg and rain down blood and sorcery upon them. In this instance they are three individuals yet are still acknowledged as the Morrigan. The simplest answer, and the one that seems to hold true to my own experiences, is that she is all these things. A whole and a collective simultaneously. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("How I thought of and approached the Morrigan changed very much from the first time I offered her my service to my current practices. When I first encountered her, I was aware that she was made up of three individual goddesses, but I saw her very much as a single being. Even today I can say I see the collective whole that is the Morrigan as an individual being that has a separate personality and energetic feel to her. Whether this unified collective is the combined hive mind of Anu, Macha, and Badb I cannot say, only that when I speak to the totality of the Morrigan, she has a particular feel. That said, that “totality” cannot be confused for the energy and personality of Badb or Macha when I encounter them or any of her other faces as individuals. It took me a long time to learn who these beings were both individually and as a whole. Today I tend to look at it as a kind of godly multiple personality disorder or a hive mind akin to something you would see in science fiction. Anu, Macha, and Badb exist separately from one another and can act separately from one another. They are whole and complete "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page10",
      "title": "10"
    }
  }, [_vm._v("gods themselves, yet together they form something different and unique that has its own identity and agency. At least, this is how my human mind tries to conceptualize what I am experiencing.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("That all being said, when I set out to dedicate myself to the Morrigan as her priestess, I didn’t realize that the process would encompass several initiatory experiences. Initiation can happen several ways. There are the experiences that we seek out, as my first initiation as a priestess was. I felt called to do this work. I spent time doing divination and journey work confirming I was going down the right path. Then I simply went out into the woods and did a simple ritual offering my vows to the Morrigan, made libations, and that was it. Or so I thought. Just because I was a priestess of the Morrigan didn’t mean I was instantly a priestess of Macha, Badb, or Anu. That would come later. ")]), _vm._v(" "), _c('p', {
    staticClass: "Bhead"
  }, [_vm._v("What does it mean when the Morrigan is silent?")]), _vm._v(" "), _c('p', {
    staticClass: "tx-ni"
  }, [_vm._v("I do not think this is unique to the Morrigan, but the Morrigan’s silences seem to be taken more harshly than the silence of other gods by her followers. Because of her reputation as a goddess of war, no one wants to make her angry. In general, the Morrigan isn’t very shy about making her presence known, so when that presence goes away, it can seem sudden and like a harsh reprimand. When a deity’s presence and voice seem to disappear from us when we are used to feeling a close connection to them or receiving messages often, it is usually perceived as anger on the deity’s part. This can very well be the case. If the Morrigan is quiet or if her presence feels far away, it could be due to a misstep on the part of the devotee. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("For me, her silence often means I’m not listening to what she is trying to tell me. If she has been trying to tell you something ten different times, she just doesn’t think that eleventh time she sends an omen or message your way is going to make any difference. Retreating, making their presence lessened, seems to be the way the gods force our hand to make the next move. Your concern that the Morrigan might be pissed at you might make you take the time to do daily devotions, to make time to pour her an offering and spend time connecting to her. Just experiencing the gods occasionally in ritual or on a sabbat isn’t enough if you want to have a deep connection to them. You have to put in the work of connecting with them in your daily life. Silences can signal"), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page11",
      "title": "11"
    }
  }, [_vm._v(" that one has been neglecting those daily practices or, for me, that she has already given me the answers I seek. ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Other times silences can mean that another deity wants your attention or simply that the Morrigan is going to show up only at certain times in your life. Not every deity will be one you have a lifelong, complicated relationship with. The depth of the relationship will vary from deity to deity. She may appear in your life very strongly, then step back into the background, always there but not center stage, because maybe another devotion needs to be center stage for you. ")]), _vm._v(" "), _c('p', {
    staticClass: "Bhead"
  }, [_vm._v("What is Anu like? ")]), _vm._v(" "), _c('p', {
    staticClass: "tx-ni"
  }, [_vm._v("Anu (pronounced "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("AH-nu")]), _vm._v(") can be difficult for many to connect to because we don’t have any of her stories. Because the Paps of Anu (two breast-like hills in Ireland) are named for her, I first started my connection to Anu through connecting and taking care of the land I lived on. To me Anu is the sovereignty of the land that flowed to the king. She feels strong and eternal like a mountain to me. She is every inch the queen. But she is not the queen defending her claim like Macha; she is the strong ruler who knows the weight of her crown and how to rule well. She is comfortable with power and uses it. Anu is the one I go to for the kind of strength that grows things and lets them thrive rather than tears them down. Her sisters are about tearing things apart to make them stronger and burning out the rot, while Anu is about making them whole and sustainable again. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I also view Anu as the true name of the Morrigan. Since "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("the Morrigan")]), _vm._v(" is a title, it makes sense that she would have a name in addition to the title. As earlier noted, in the "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("Lebor Gab")]), _c('span', {
    staticClass: "ital",
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }, [_vm._v("á")]), _c('span', {
    staticClass: "ital"
  }, [_vm._v("la ")]), _c('span', {
    staticClass: "ital",
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }, [_vm._v("Érenn")]), _vm._v(", which lists many of the genealogies of the gods, we are told, “Ernmas had other three daughters, Badb and Macha and Morrigu, whose name was Anand.” "), _c('span', {
    staticClass: "fnref _idGenCharOverride-2"
  }, [_c('span', {
    attrs: {
      "id": "footnote-008-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/PM2#footnote-008"
    }
  }, [_vm._v("3")])])]), _vm._v(" This would suggest that the Morrigan’s true name is Anu (here given with the nonstandard spelling). ")]), _vm._v(" "), _c('p', {
    staticClass: "Bhead"
  }, [_vm._v("What is Macha like? ")]), _vm._v(" "), _c('p', {
    staticClass: "tx-ni"
  }, [_vm._v("Macha (pronounced "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("MA-ka")]), _vm._v("), like Badb, is multifaceted. There is more than one Macha, or at least she has several incarnations within her stories, often dying only to pop up again alive and well. Macha is complicated; there are five different "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page12",
      "title": "12"
    }
  }, [_vm._v("faces of Macha in Irish lore, and she can easily be worshiped as a multifaced goddess on her own. ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Macha embodies the kind of strength that endures against all odds. She does not make rash decisions; she is full of strategy. Even as the fierce warrior queen, Macha exudes a kind of control over her power and fury. She has mastered herself. Like Anu, I find her more concerned with building things up. She certainly can destroy and burn things down, but she also values strong foundations. She makes me think of an old general who has seen many battles and knows from experience what is worth putting her energy into and what isn’t. ")]), _vm._v(" "), _c('p', {
    staticClass: "Bhead"
  }, [_vm._v("What is Badb like? ")]), _vm._v(" "), _c('p', {
    staticClass: "tx-ni"
  }, [_vm._v("Like Macha, there is more than one face to Badb (pronounced "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("BYE-vh")]), _vm._v("). There is the side of her that is Cath Badb (meaning “battle crow”), who dances on spearpoints and is all battle frenzy and battle madness. She is not about controlled force as Macha is; instead, she is the wild, destructive energy of a storm. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Then there is Badb as the Washer at the Ford. When Badb is the Washer Woman, she is calmer, focused on the cleansing that is needed for the aftermath of battle. She can be just as dangerous and harsh as Cath Badb, but for the most part I have found her to be a source of comfort when approached with respect. Someone to mourn beside you, who guides you toward releasing grief and trauma. When I see her as the Washer Woman, she has long black hair that covers her face like a veil, her fingers long, almost like bird talons. The river that she washes in has significance in my own personal unverified personal gnosis (UPG). For me, it is the river of life, death, and rebirth; it is where we all journey to when we leave this world to be cleansed and wash away our burdens. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("And finally, there is Badb the prophetess. Of all the Morrigan’s faces, Badb is the most connected to prophecy. She is specifically named as the one who speaks the Morrigan’s famous prophecy at the end of "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("The")]), _vm._v(" "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("Second Battle of Moytura")]), _vm._v(", after the Tuatha Dé Danann have defeated their enemies the Fomorians, and she also appears to Maeve in a dream to warn her of her son’s death. Although I see this part of her as separate from the Washer Woman, it is important to note that the entire function of the Washer at the Ford in the mythology is as a death omen. Where Badb is, there is some element of prophecy and seeing into the future. In this guise she appears to me as a tall pale woman with black "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page13",
      "title": "13"
    }
  }, [_vm._v("hair, a regal, unbending air about her. She is calm and collected, watching the swirling factors and possible threads of future events, seeing which threads to pull. I have also encountered her as a pale, wraithlike woman, completely bone white from head to toe, as if all the color and pigments were drawn out of her skin, hair, eyes, and clothes.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Of the three, Badb is the harshest of the sisters. That isn’t necessarily a bad thing. She is direct and cutting at times, but I feel her directness is mostly because she sees to the heart of things. No truth can be hidden from her. We concern ourselves with the lies and illusions we spin around ourselves, but Badb sees past those and demands that we rip out those lies from our hearts.")]), _vm._v(" "), _c('p', {
    staticClass: "Bhead"
  }, [_vm._v("Isn’t Nemain one of the three Morrigans?")]), _vm._v(" "), _c('p', {
    staticClass: "tx-ni"
  }, [_vm._v("Nemain (pronounced "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("neh-VAN ")]), _vm._v("and alternatively spelled Neman) is given a different genealogy than Anu, Macha, and Badb in the "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("Lebor Gab")]), _c('span', {
    staticClass: "ital",
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }, [_vm._v("á")]), _c('span', {
    staticClass: "ital"
  }, [_vm._v("la ")]), _c('span', {
    staticClass: "ital",
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }, [_vm._v("Érenn")]), _vm._v(". The trio we know as the Morrigan are the daughters of Ernmas, while Neman is named as a daughter of Elcmar. They clearly have different parentage, so why are they so often equated? ")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("In his work “The Ancient Irish Goddess of War,” W. M. Hennessy mentions Nemain several times, although never names her specifically as one of the Morrigan."), _c('span', {
    staticClass: "fnref CharOverride-3"
  }, [_c('span', {
    attrs: {
      "id": "footnote-007-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/PM2#footnote-007"
    }
  }, [_vm._v("4")])])]), _vm._v(" Hennessy wrote in the 1800s, and there is no doubt that his work influences modern Neopagan authors looking for information about the Morrigan or Irish war deities. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Nemain and Badb are named as the two wives of the war god Neit in the "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("Lebor Gab")]), _c('span', {
    staticClass: "ital",
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }, [_vm._v("á")]), _c('span', {
    staticClass: "ital"
  }, [_vm._v("la ")]), _c('span', {
    staticClass: "ital",
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }, [_vm._v("Érenn")]), _c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v(": ")]), _vm._v("“Neit son of Indu and his two wives, / Badb and Neman.” "), _c('span', {
    staticClass: "fnref _idGenCharOverride-2"
  }, [_c('span', {
    attrs: {
      "id": "footnote-006-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/PM2#footnote-006"
    }
  }, [_vm._v("5")])])]), _vm._v(" Although in other places, Nemain and Fea are named as Neit’s two wives."), _c('span', {
    staticClass: "fnref _idGenCharOverride-2"
  }, [_c('span', {
    attrs: {
      "id": "footnote-005-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/PM2#footnote-005"
    }
  }, [_vm._v("6")])])]), _vm._v(" Badb and Nemain appear alongside each other, working together to confuse a part of the enemy host when Cuchulain lets out a mighty shout in "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("The")]), _vm._v(" "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("Cattle Raid of Cooley, ")]), _vm._v("a story that details how Queen Maeve tries to steal a bull from Ulster and how the hero Cuchulain single-handedly fights her army. Since Badb is both a proper name of a goddess and also a term used to describe a war fury, it is unclear if Nemain is simply being described as a "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("badb,")]), _vm._v(" “fury,” in the text or if the word "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("badb")]), _vm._v(" is being used as a proper name, indicating that both the "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page14",
      "title": "14"
    }
  }, [_vm._v("goddess Badb and the goddess Nemain were present."), _c('span', {
    staticClass: "fnref _idGenCharOverride-2"
  }, [_c('span', {
    attrs: {
      "id": "footnote-004-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/PM2#footnote-004"
    }
  }, [_vm._v("7")])])]), _vm._v(" If that is the case, then they have no true connection other than that they are both spirits connected to battle, and Nemain can be described as a "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("badb,")]), _vm._v(" or war fury.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("For a very long time I was convinced this was the case, and that they were separate, unrelated deities. While out of the three Morrigans Badb has always felt the most wild and fierce to me, Nemain felt even more so. Whenever I encountered her, she appeared naked, covered in blood. But over time I noticed that when Badb appeared Nemain was not far away. I would call to Badb and Nemain would show up with her in tow, so eventually I included her in my worship of Badb. I still do not see her as one of the Morrigans, but I do see her as a sister to Badb, and they can be worshipped as a divine pair.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("What I think is the most likely explanation for Nemain being equated with Badb is that at one point in time they formed a sacred dyad. That is a dual-faced set of deities or a set of sisters, just as the Morrigan is a set of three sisters. Over time for whatever reason Badb became absorbed into the trinity that is now the Morrigan, and Nemain’s worship became separate from Badb’s. This would explain why while they have different genealogies, they still were both named as the wives of Neit, perhaps indicating they are one and the same or were seen as such at one point. They also have the same epithets, being described as red mouthed, a further indication of their connection at one point in time. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The simple answer is that Nemain is not one of the three Morrigans, but she is connected to Badb, who is. Confusing, right? Welcome to Irish mythology. ")]), _vm._v(" "), _c('p', {
    staticClass: "Bhead"
  }, [_vm._v("What does the Morrigan look like?")]), _vm._v(" "), _c('p', {
    staticClass: "tx-ni"
  }, [_vm._v("I think the reason I encounter this question so frequently is that we all seek confirmation that our encounters with deity, whether they be in dreams or journey work, are valid. If we are all seeing the same hallucination, then logically it’s not really a hallucination. We want to know what we are experiencing is real. Most people who encounter the Morrigan describe her as a pale woman with dark hair. Others see her as a redhead. Is there a correct answer?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("If you are a student of Irish mythology, you will notice fairly quickly that Irish lore is filled with intricately detailed descriptions about weapons and what a person is wearing. Great detail might be put into describing a person’s clothes, "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page15",
      "title": "15"
    }
  }, [_vm._v("but rarely are details given about the people themselves. We may be told all about a character’s size, his strength, and the pattern of the tunic he wears, but we don’t know what his hair or eye color is, for example. He or she might simply be described as fair, and we are left to fill in our own version of that for ourselves. The Morrigan is no different. ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("Táin Bó Regamna")]), _vm._v(" is the only instance where anything about her physical appearance is mentioned. Yet even this is suspect because she is a shape-shifter, so we don’t really know if the description is her true form. We are told she has red hair and red eyebrows: “A red woman was in the chariot, and a red mantle was about her, she had two red eye-brows, and the mantle fell between the two "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("ferta")]), _vm._v(" of her chariot.” "), _c('span', {
    staticClass: "fnref _idGenCharOverride-2"
  }, [_c('span', {
    attrs: {
      "id": "footnote-003-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/PM2#footnote-003"
    }
  }, [_vm._v("8")])])]), _vm._v(" When the hero Cuchulain challenges her in this guise, he does not recognize her until she turns into a crow. In most of their interactions the hero only seems to recognize the Morrigan in animal form, which may mean that the red woman she appears as may still not be her true form. I would argue that as a shape-shifter, she may not really have a true form, other than what she appears as in the moment at hand. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("In "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("The")]), _vm._v(" "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("Cattle Raid of Cooley")]), _vm._v(" when the hero encounters her again in human form, she is an old woman. Here we are given no more description other than her age. Alternatively, in a dream Queen Maeve encounters her as a pale young woman, which I think just drives home the point that the Morrigan will appear however she wants to appear, given the situation. Similarly, in another appearance the Morrigan is described as dancing from spearpoint to spearpoint in the form of a naked hag. When she appears as an old woman, the words used to describe her are "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("senntaine ")]), _vm._v("and "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("cailleach")]), _vm._v("."), _c('span', {
    staticClass: "fnref _idGenCharOverride-2"
  }, [_c('span', {
    attrs: {
      "id": "footnote-002-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/PM2#footnote-002"
    }
  }, [_vm._v("9")])])]), _vm._v(" "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("Cailleach")]), _vm._v(", while also the name of a goddess, means “old woman” or a “hag.” This description may be why some modern worshipers conflate the two deities, even though they have no true connection in mythology. Young or old, animal or human. As far as the lore is concerned, the one time we do have a description of her, she is a red-headed woman of indeterminate age. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I don’t really think there is one single answer to what the Morrigan looks like. I have experienced her as a pale woman with black hair when she is Badb "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page16",
      "title": "16"
    }
  }, [_vm._v("and Anu, while Macha for me appears as a tall red-haired woman. She is very fluid in my mind, as I think a shape-shifter should be. I have also had those close to me experience the Morrigan appearing to them in dreams wearing my face to impart a message to them. They recognized me, but on some level, they were aware that it wasn’t really me. This has happened to several different people and often enough that when I asked the Queen why she was appearing this way, the answer she gave me was simple: I wore her face when I did oracular work, so it was only fair that she could at times wear my face. I think this boils down to the fact that the Morrigan can appear any damn way she pleases. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Bhead"
  }, [_vm._v("Does being a follower of the Morrigan mean you must be a spiritual warrior?")]), _vm._v(" "), _c('p', {
    staticClass: "tx-ni"
  }, [_vm._v("There are several problems with this concept, not the least being that those who take up the title of "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("spiritual warrior")]), _vm._v(" tend to have very different mindsets than military personnel and those in law enforcement who, from a modern perspective, are literal warriors for a living. A spiritual warrior is not above someone who puts their life on the line and participates in the physical side of warriorship. The simple answer to this question is no. If the Morrigan has called to you, then there is something about you that she is interested in. She may make you face things about yourself and instigate change, but no one should feel the need to take on a title or work that they are not comfortable with. Ultimately, feeling that one needs to be a warrior to honor the Morrigan is essentially turning a blind eye to her other aspects. She is just as much a goddess of war as she is a goddess of prophecy, yet I see few modern devotees concerned that worshiping the Morrigan will also require them to learn oracular work. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('span', {
    staticClass: "ital"
  }, [_vm._v("Warrior")]), _vm._v(" is a term that means many things to different people and may not be appropriate for you. That’s perfectly okay. The Morrigan gives us each different marching orders, if you will. Being a devotee of the Morrigan means you are cultivating a deep connection with this particular Irish goddess; it doesn’t mean you’ve been spiritually recruited into the Morrigan’s army. ")]), _vm._v(" "), _c('p', {
    staticClass: "Bhead"
  }, [_vm._v("Is the Morrigan cruel? Does the Morrigan break her devotees?")]), _vm._v(" "), _c('p', {
    staticClass: "tx-ni"
  }, [_vm._v("I encounter this question often. Perhaps because many devotees in the Morrigan community speak openly about times when they have ignored what she was trying to tell them or weren’t upholding their end of a promise and it went badly. I have a friend who tells the story of how the Morrigan hit her with a bus "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page17",
      "title": "17"
    }
  }, [_vm._v("just to get her to start listening. No metaphor there, either—quite literally a real bus. She tends to know exactly what will get through to her followers, how exactly to break you when you aren’t quite getting a lesson you need to learn. The Morrigan has never hit me with a bus, but she has broken my heart in painful ways, ways that were the only way for me to learn certain things, ways that transformed me into what I needed to be. I don’t ignore the Morrigan when she is trying to tell me something anymore. Even if I don’t understand at first, I listen. I seek omens and consult divination. Not listening seems to be what brings on her harsher side. But I must emphasize that this is part of having oaths to a deity or being in a deity’s service. I chose to be her priestess. I chose this kind of connection to her. Those oaths have consequences. For someone who may just be a devotee of the Morrigan, who worships her and feels a strong connection to her but has offered no oath of service, priesthood, or otherwise, I do not feel the consequences for not listening to something she is trying to tell you would be the same. Breaking an oath or not doing something you promised a deity, any deity, is never a good idea. Think before you speak or make grand oaths. ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("As for her being cruel, there is a difference between cruelty and harshness. The Morrigan is harsh at times, yes. But not all the time. She is willing to be harsh because she expects us to become better than we are. That requires tough love, and I do believe she cares about those who call to her. This idea that the Morrigan is constantly angry is an unhealthy one. Devotional work has consequences because we are dealing with forces that are more powerful than ourselves. There is risk there, but also reward. That doesn’t make her an angry, hateful goddess. ")]), _vm._v(" "), _c('p', {
    staticClass: "Bhead"
  }, [_vm._v("Can you worship other gods alongside the Morrigan?")]), _vm._v(" "), _c('p', {
    staticClass: "tx-ni"
  }, [_vm._v("Since my house is basically one giant collection of altars and temple spaces dedicated to a multitude of gods, I can safely say yes. The Morrigan’s altar space is certainly the largest, since she is the primary focus of my spiritual work, but she is not the only deity I worship. I have close devotional relationships with many deities. The very nature of being Pagan or a polytheist implies one may have several gods that they worship or have dedications to. I have seen others insinuate that if the Morrigan is not held on a higher pedestal than other deities, there will be dire consequences, but this just isn’t true. What I can see "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page18",
      "title": "18"
    }
  }, [_vm._v("being a problem with any deity is if you worship a god and give them regular offerings, discover another deity’s presence in your life, and then just up and stop making offerings or paying any attention to the first deity. Ignoring a deity you have made oaths to or who is used to receiving regular offerings can cause issues regardless of who that deity is. If you are going to honor multiple gods then you have to make room in your life for all of them. As long as you are holding up your obligations to the Morrigan there is no reason the Morrigan would be upset if you honored other deities. There are certain deities within pantheons that do not get along based on their mythology, but that is a different scenario entirely. ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("In many cases I find that the Morrigan may work with other gods to convey a message or lessons. For me, the Morrigan has often worked in tandem with Brigid as well as the Dagda. For whatever reason, I have noticed that those who have a devotion to Odin and Hekate seem to also find that the Morrigan is courting or calling to them as well.")]), _vm._v(" "), _c('p', {
    staticClass: "Bhead"
  }, [_vm._v("Is Morgan le Fay the same as the Morrigan?")]), _vm._v(" "), _c('p', {
    staticClass: "tx-ni"
  }, [_vm._v("Although her name sounds similar to the Irish Morrigan, Morgan le Fay is purely of Welsh origin. Her name is likely derived from Old Welsh "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("Mori-gen")]), _c('span', {
    staticClass: "ital CharOverride-5"
  }, [_vm._v("ā")]), _c('span', {
    staticClass: "ital"
  }, [_vm._v(",")]), _vm._v(" meaning “Sea Born,” "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("mor")]), _vm._v(" meaning “sea.” "), _c('span', {
    staticClass: "fnref CharOverride-3"
  }, [_c('span', {
    attrs: {
      "id": "footnote-001-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/PM2#footnote-001"
    }
  }, [_vm._v("10")])])]), _vm._v(" Her epithet "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("le Fay, ")]), _vm._v("from the French "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("la fée")]), _vm._v(", or “the fairy,” was added in the fifteenth century by Thomas Malory. However, Morrigan is derived from Irish "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("rigan,")]), _vm._v(" meaning “queen,” and "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("mor,")]), _vm._v(" meaning “great.” ")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("But "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("mor")]), _vm._v(" looks and sounds similar in Irish and Old Welsh—why does it have two separate meanings within two cultures fairly geographically close to one another, you ask? Well, Celtic languages fall into two branches: P-Celtic and Q-Celtic. P-Celtic, from which Morgan le Fay’s name stems, includes Gaulish, Cornish, and Welsh. Q-Celtic consists of Irish, Scottish, and Manx Gaelic."), _c('span', {
    staticClass: "fnref _idGenCharOverride-2"
  }, [_c('span', {
    attrs: {
      "id": "footnote-000-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/PM2#footnote-000"
    }
  }, [_vm._v("11")])])]), _vm._v(" Similar languages, but they evolved differently.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Besides her name having a completely different etymology than the Morrigan, it is also very clear that Morgan le Fay evolved from the stories of the Welsh goddess Modron, eventually being diminished into a mortal character, a fate shared by many of the Welsh gods. Modron, notably, does have some "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page19",
      "title": "19"
    }
  }, [_vm._v("similarities to the Morrigan, which adds to the confusion. But no, Morgan le Fay is not the Morrigan. ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("From my point of view, Morgan le Fay’s energy feels very different from the Morrigan’s, and I do not view them as the same deity. Similarly, many people equate Badb and Nemain, but they both have very distinct and individual energies and personalities in my opinion. They aren’t the same to me. Just as Kali and the Morrigan may have similarities, that doesn’t automatically mean they are the same deity. Yet many people do connect to the Morrigan through Morgan le Fay and have meaningful experiences. What does that mean? Are they really connecting to the Welsh Modron? Are their experiences just fanciful and not valid encounters with deity? This is the thing with UPG—it’s never simple. And this is the reason I wrote about Morgan le Fay in my first book. Just because I didn’t see the Morrigan and Morgan le Fay as the same goddess didn’t mean that the people who had experienced the Morrigan in this way had anything less valid than my own encounters with her. Sometimes the gods speak to us however they wish. For those I have met who do connect to the Morrigan in this guise, working with her often revolves around reclaiming their own sexuality or healing sexual trauma. Something in Morgan le Fay’s story might embody that better than the Morrigan’s. Perhaps that is why she chooses this face to speak to them through. I do not know. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I think the lesson here is that the gods will speak to us through whatever medium they choose. Also, we need to be able to accept that when there isn’t a connection in the lore and mythology to something we are experiencing, it’s because it has more to do with us and the personal lessons we need to learn, rather than the experience being a statement about the nature of the deity. ")]), _vm._v(" "), _c('p', {
    staticClass: "Bhead"
  }, [_vm._v("Is the Morrigan a triple goddess?")]), _vm._v(" "), _c('p', {
    staticClass: "tx-ni"
  }, [_vm._v("In the sense that the Morrigan comprises three sisters, yes. In the sense of Maiden, Mother, Crone, no. Most triads of goddesses don’t fit that model. It is, in the end, an interpretation by Robert Graves of how he viewed the Goddess, not something that can be applied to every triple set of female deities. The Morrigan does appear both young and old. She does have children, but she isn’t a mother goddess. She happens to have children, like many women. It’s not the defining aspect of herself or her function as a deity. When she appears as a young woman, she isn’t very innocent, and it is usually a disguise so the "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page20",
      "title": "20"
    }
  }, [_vm._v("hero or person she is encountering won’t recognize her. She wears most of her forms as very interchangeable skins, and they have more to do with her purpose at the time than reflecting a stage in a woman’s life. Ultimately, connecting the Morrigan to the Maiden, Mother, Crone concept has more to do with modern Neopagan ideology than it does with how the Morrigan was viewed by the Irish. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Bhead"
  }, [_vm._v("Do you have to be a Reconstructionist to honor the Morrigan?")]), _vm._v(" "), _c('p', {
    staticClass: "tx-ni"
  }, [_vm._v("The simple answer is no. I find this question cropping up a lot as there is now a stronger push to look back at authentic Irish practices. Learning more about the culture the Morrigan comes from should be very important to anyone who worships her. I think it’s a good thing that people want to understand what authentic Irish folk belief is and what comes from modern concepts. Yet I also have seen many people who are Wiccan and worship the Morrigan shamed for not being “hard-core” enough because they don’t worship her in the way a Celtic Reconstructionist would. I started my own path in Wicca and then moved on to a more devotional path, but it was only because that was what worked for me. I try to use what works tempered with what we know about the past and mix that with my own gnosis, which makes me an odd kind of hybrid. That may not work for you, and that’s fine. It matters that you approach your devotion and worship in a meaningful way. It doesn’t matter if you are Wiccan, Reconstructionist, or something else. I know devotees of the Morrigan who have deep, meaningful relationships with her and practice in vastly different ways, ways that would probably cause both parties to point to the other and say, “You are doing it all wrong!” The point is I don’t think the Morrigan cares. All our modern practices probably look nothing like how she was worshiped in the past. Is it valuable to know about Irish culture? Yes, absolutely, just like it is important to understand the origins of modern occult practices and techniques. In the end, all that matters is that she is being worshiped. The manner in which that is done doesn’t matter so much in my opinion. I think her devotees have stronger feelings about the subject than the Morrigan herself does.")]), _vm._v(" "), _c('p', {
    staticClass: "Bhead"
  }, [_vm._v("Is the Morrigan Brigid’s mother? Who are her children?")]), _vm._v(" "), _c('p', {
    staticClass: "tx-ni"
  }, [_vm._v("We are told that Brigid’s father is the Dagda, but we are never told who her mother is. At least when we are talking about Brigid, the goddess of the Tuatha "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page21",
      "title": "21"
    }
  }, [_vm._v("Dé Danann. Brigid the Christian saint has her own storyline for her parentage. Since the Morrigan and the Dagda are said to be husband and wife, it is not out of the realm of possibility, but we really don’t know, which is to say Brigid’s mother could be any of the Irish goddesses. What is absolutely out of the realm of possibility is that Brigid is conceived during the union the Morrigan and the Dagda have at Samhain in "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("The Second Battle of Moytura")]), _vm._v(". Why? Because at this point in the stories of the Irish gods, Brigid was already an adult, married to Bres, the king who was overthrown and caused the battle in this story in the first place. She even already has sons who are grown at this point who fight in the battle. Could she be a child of the Morrigan and Dagda from an earlier union? It’s possible, but we just don’t know. The Dagda does have children with other goddesses as well, so really this is something you have to make your own judgments on. There is no real evidence for it or against it. ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The Morrigan does have other children. In the "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("Dindshenchas")]), _vm._v(", a collection of lore concerning Irish place names, we are told Meiche (pronounced "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("MEH-kah")]), _vm._v(" with the "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("k")]), _vm._v(" sound as in "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("loch")]), _vm._v(") is a son of the Morrigan, although we are never told who his father is. Meiche comes to an unfortunate end when serpents begin growing in his three hearts. Yes, when you are a god, why have one heart when you can have three? In one recension of the "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("Lebor Gab")]), _c('span', {
    staticClass: "ital",
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }, [_vm._v("á")]), _c('span', {
    staticClass: "ital"
  }, [_vm._v("la ")]), _c('span', {
    staticClass: "ital",
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }, [_vm._v("Érenn")]), _vm._v(" the Morrigan is said to be the mother of Brian, Lucharba, and Luchair by her own father, Delbaeth. In other versions this trio is said to be the children of Brigid, perhaps further confusing their connection and blood ties.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Another child of the Morrigan, Adair, is mentioned in an index of "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("The Second Battle of Moytura")]), _vm._v(". We are told almost nothing about her other than she was a daughter of the Morrigan by the Dagda and that she later married a man named Eber.")]), _vm._v(" "), _c('p', {
    staticClass: "Bhead"
  }, [_vm._v("Why are there so many versions of the Morrigan’s stories?")]), _vm._v(" "), _c('p', {
    staticClass: "tx-ni"
  }, [_vm._v("Trying to sort out Irish mythology can be pretty overwhelming. Perhaps the most frustrating aspect of delving into Irish mythology is that there are multiple versions of a single story, known as recensions. This means the same story appears in different manuscripts, and they are not exact copies of each other. Since we have many versions of the same stories in various manuscripts, in some versions a character might do one thing, then in another version of the same story a different character is attributed to that plot point or named as the "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page22",
      "title": "22"
    }
  }, [_vm._v("parent of someone, contradicting the other version of the story. For example, in the story of Cuchulain’s wasting sickness the name of his wife keeps changing for no apparent reason. This may be due to regional variations for certain stories prior to them being collected and written down. "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("The Second Battle of Moytura")]), _vm._v(" is the rare exception, since we have only one manuscript surviving with this story. However, although we only have one manuscript for this text, you will still find various differing English translations. Some translators may have chosen to not translate several passages if they contained difficult to translate language. In "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("The Second Battle of Moytura")]), _vm._v(" translator Elizabeth A. Gray skips over a whole paragraph of Lugh speaking to Balor. The English text skips ahead with Balor commenting on how talkative Lugh is, which makes no sense to the English reader because Lugh seemingly hasn’t said anything. You might not understand that we just skipped ahead a whole paragraph if you don’t have the version that gives you both the Old Irish text and the English translation side by side. Not all translations are perfect, and some of the older translations tend to have wording that fits the translator’s perspective or morals from that time rather than being true to the text. We can see this in translations that edit out the Morrigan washing her genitals at the river ford prior to her meeting with the Dagda. ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("To further confuse the English reader, sometimes a story will be referenced using its Irish name, and other times it may be referenced by its English name, causing more confusion if you don’t realize they are the same thing. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("For stories pertaining to the Morrigan, it is good to start with both of the battles of Moytura and the Ulster Cycle, which includes "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("The Cattle Raid of Cooley")]), _vm._v(". You will find a short description of all the stories referenced in this book in the "), _c('a', {
    attrs: {
      "href": "#/PM22#_idTextAnchor037"
    }
  }, [_vm._v("Appendix")]), _vm._v(", starting on "), _c('a', {
    attrs: {
      "href": "#/PM22#_idTextAnchor038"
    }
  }, [_vm._v("page 237")]), _vm._v(", as well as links to read the materials for yourself. ")]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('a', {
    attrs: {
      "href": "#/Contents#_idTextAnchor000"
    }
  }, [_vm._v("[contents]")])]), _vm._v(" "), _c('hr', {
    staticClass: "HorizontalRule-1"
  }), _vm._v(" "), _c('div', {
    staticClass: "_idFootnotes"
  }, [_c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "epub:type": "footnote",
      "id": "footnote-010"
    }
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/PM2#footnote-010-backlink"
    }
  }, [_vm._v("1")]), _vm._v(". R. A. Stewart MacAlister, trans., "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("Lebor Gabála Érenn: The Book of the Taking of Ireland,")]), _vm._v(" "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("Part IV, ")]), _vm._v("Irish Texts Society, vol. 41 (Dublin: Irish Texts Society, 1956), 131.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "epub:type": "footnote",
      "id": "footnote-009"
    }
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/PM2#footnote-009-backlink"
    }
  }, [_vm._v("2")]), _vm._v(". A. H. Leahy, trans. and ed., "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("Heroic Romances of Ireland, ")]), _vm._v("vol. 2"), _c('span', {
    staticClass: "ital"
  }), _vm._v("(London: David Nutt, 1906),"), _c('span', {
    staticClass: "ital"
  }), _vm._v("132.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "epub:type": "footnote",
      "id": "footnote-008"
    }
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/PM2#footnote-008-backlink"
    }
  }, [_vm._v("3")]), _vm._v(". MacAlister, "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("Lebor Gabála Érenn, Part IV,")]), _vm._v(" 131.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "epub:type": "footnote",
      "id": "footnote-007"
    }
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/PM2#footnote-007-backlink"
    }
  }, [_vm._v("4")]), _vm._v(". W. M. Hennessy, “The Ancient Irish Goddess of War,” "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("Revue Celtique")]), _vm._v(" 1 (1870–72): 32–55.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "epub:type": "footnote",
      "id": "footnote-006"
    }
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/PM2#footnote-006-backlink"
    }
  }, [_vm._v("5")]), _vm._v(". MacAlister, "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("Lebor Gabála Érenn")]), _vm._v(", "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("Part IV,")]), _vm._v(" 237"), _c('span', {
    staticClass: "ital"
  }, [_vm._v(".")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "epub:type": "footnote",
      "id": "footnote-005"
    }
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/PM2#footnote-005-backlink"
    }
  }, [_vm._v("6")]), _vm._v(". MacAlister, "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("Lebor Gabála Érenn")]), _vm._v(", "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("Part IV")]), _vm._v(", 123 and 131.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "epub:type": "footnote",
      "id": "footnote-004"
    }
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/PM2#footnote-004-backlink"
    }
  }, [_vm._v("7")]), _vm._v(". Thomas Kinsella, trans., "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("The Táin: Translated from the Irish Epic Táin Bó Cuailnge ")]), _vm._v("(New York: Oxford University Press, 1969), 167.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "epub:type": "footnote",
      "id": "footnote-003"
    }
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/PM2#footnote-003-backlink"
    }
  }, [_vm._v("8")]), _vm._v(". Leahy, "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("Heroic Romances of Ireland, ")]), _vm._v("vol. 2,"), _c('span', {
    staticClass: "ital"
  }), _vm._v("132.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "epub:type": "footnote",
      "id": "footnote-002"
    }
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/PM2#footnote-002-backlink"
    }
  }, [_vm._v("9")]), _vm._v(". Morgan Daimler, “The Morrigan, Questions and Answers,” Irish-American Witchcraft, "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("Patheos")]), _vm._v(" "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("Pagan")]), _vm._v(" (blog), November 17, 2017, https://www.patheos.com/blogs/agora/2017/11/irish-american-witchcraft-morrigan-questions-answers/.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "epub:type": "footnote",
      "id": "footnote-001"
    }
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/PM2#footnote-001-backlink"
    }
  }, [_vm._v("10")]), _vm._v(". Rosalind Clark, "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("The Great Queens: Irish Goddesses from the Morrígan to Cathleen ní Houlihan")]), _vm._v(" (Gerrards Cross, UK: Colin Smythe, 1991), 22.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "epub:type": "footnote",
      "id": "footnote-000"
    }
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/PM2#footnote-000-backlink"
    }
  }, [_vm._v("11")]), _vm._v(". Martin J. Ball and James Fife, eds., "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("The Celtic Languages")]), _vm._v(" (London: Routledge, 1993), 67.")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6697f4e8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PM-2.vue
// module id = 78
// module chunks = 0